import { cn } from '@/lib/utils';
import NextImage, { ImageProps as NextImageProps } from 'next/image';

type ImageProps = Omit<NextImageProps, 'objectFit'> & {
  objectFit?: 'contain' | 'cover' | 'none' | 'scale-down';
  size?: 'xs' | 'small' | 'medium' | 'large';
  inGrid?: boolean;
};

/**
 * a custom image component wrapper, designed to be used in place of the next/image component.
 *
 * You can still use NextImage, but using this component is preferred.
 */
export const Image = (props: ImageProps) => {
  const { src, alt, fill, objectFit, sizes, size = 'medium', style, loading, inGrid = false, ...rest } = props;
  return (
    <NextImage
      fill={fill}
      src={src}
      alt={alt}
      sizes={sizes ? sizes : fill ? getSizes(size) : undefined}
      style={{ objectFit: objectFit ?? 'contain', ...style }}
      loading={inGrid && !loading ? 'eager' : loading}
      {...rest}
    />
  );
};

export const getSizes = (size: 'xs' | 'small' | 'medium' | 'large') => {
  switch (size) {
    case 'xs':
      return '80px';
    case 'small':
      return '(max-width: 380px) 100vw, (max-width: 695px) 50vw, (max-width: 800px) 33vw, (max-width: 930px) 25vw, 20vw';
    case 'large':
      return '(max-width: 580px) 100vw, (max-width: 1085px) 50vw, 33vw';
    case 'medium':
    default:
      return '(max-width: 490px) 100vw, (max-width: 1000px) 50vw, 33vw';
  }
};
